import _ from 'lodash';
import PropTypes from 'prop-types';
import React, {SyntheticEvent, useContext, useEffect, useRef, useState} from 'react';
import postal from 'postal';

import {useHistory} from 'react-router-dom';
import {useAppDispatch, useAppSelector} from '../app/hooks';
import {usePopper} from 'react-popper';

import {faFilter} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

import {NavigationType, openNewPage} from '../util/navigationHelpers';
import {getOperationKey, stringsEqualIgnoreCase} from '../util';

import useWindowSize from '../hooks/useWindowSize';
import Menu, {IfmsMenuItem} from '../ui/menu/Menu';

import {FilterStorageVersion, isFilterObjectEmpty} from '../filtering';

import {JobMenuItem} from '../features/jobMenuSlice';
import {moveScreenToTop} from '../features/screenStackSlice';
import constants from '../constants';
import {getOpByName} from "../framework.core/JobNames";
import useJobMenus from "../hooks/useJobMenus";
import JobSwitchingMenuContext from './jobSwitchingMenuContext';
import { IfmsSideMenuWidthNumber } from '../IfmsSideMenu';
import fastStorage from '../fastStorage';
import useGlobalYesNoDialog from '../hooks/useGlobalYesNoDialog';
import { formatDate } from '../dateUtils';
import TooltipButton, { TooltipButtonItem } from '../ui/TooltipButton';
import { clearStorage } from '../features/storageSlice';
import { changeOperation, changeSideMenu, clearOperation } from '../features/operationSlice';
import { resetListScreenSettings } from '../features/listScreenSettingsSlice';
import { clearLastSavedJobs } from '../features/lastSavedJobSlice';
import localforage from 'localforage';
import useFunction from '../hooks/useFunction';
import arrowRightBlueIcon from '../img/job-switching-arrow-right-blue.svg';
import arrowLeftBlueIcon from '../img/job-switching-arrow-left-blue.svg';
// import arrowRightRedIcon from '../img/job-switching-arrow-right-red.svg';
// import arrowLeftRedIcon from '../img/job-switching-arrow-left-red.svg';
import arrowLeftGrayIcon from '../img/job-switching-arrow-left-gray.svg';
import arrowRightGrayIcon from '../img/job-switching-arrow-right-gray.svg';
import tabListIcon from '../img/job-switching-list.svg';
import circleExitRed from '../img/circle-exit-red.svg';
import circleExitWhite from '../img/circle-exit-white.svg';
import ApplicationContext from '../ApplicationContext';

interface JobMenuItemWithIndex extends JobMenuItem {
  index: number,
};

// const IncludeSearchProperties = [
//   'general1',
//   'generalText1',
// ];

const testJobMenu:Array<JobMenuItem> = [
  { url: '/', label: 'Home', operationName: 'Home', parentUrl: null, closeOnLogout: false, metadata: null, counter: 0, noOperationSuffix: false },
  { url: '/1', label: 'Branch Code List', operationName: 'Ocean Import', parentUrl: null, closeOnLogout: false, metadata: null, counter: 0, noOperationSuffix: false },
  { url: '/2', label: 'New Branch Code', operationName: 'Ocean Import', parentUrl: null, closeOnLogout: false, metadata: null, counter: 0, noOperationSuffix: false },
  { url: '/3', label: 'Edit Branch Code', operationName: 'Ocean Import', parentUrl: null, closeOnLogout: false, metadata: null, counter: 0, noOperationSuffix: false },
  { url: '/4', label: 'View Branch Code', operationName: 'Ocean Import', parentUrl: null, closeOnLogout: false, metadata: null, counter: 0, noOperationSuffix: false },
  { url: '/5', label: 'Company Type List', operationName: 'Ocean Import', parentUrl: null, closeOnLogout: false, metadata: null, counter: 0, noOperationSuffix: false },
  { url: '/6', label: 'User List', operationName: 'Ocean Import', parentUrl: null, closeOnLogout: false, metadata: null, counter: 0, noOperationSuffix: false },
  { url: '/7', label: 'New User', operationName: 'Ocean Import', parentUrl: null, closeOnLogout: false, metadata: null, counter: 0, noOperationSuffix: false },
  { url: '/8', label: 'Edit User', operationName: 'Ocean Import', parentUrl: null, closeOnLogout: false, metadata: null, counter: 0, noOperationSuffix: false },
  { url: '/9', label: 'View User', operationName: 'Ocean Import', parentUrl: null, closeOnLogout: false, metadata: null, counter: 0, noOperationSuffix: false },
  { url: '/10', label: 'Payroll Group List', operationName: 'Ocean Import', parentUrl: null, closeOnLogout: false, metadata: null, counter: 0, noOperationSuffix: false },
  { url: '/11', label: 'New Payroll Group', operationName: 'Ocean Import', parentUrl: null, closeOnLogout: false, metadata: null, counter: 0, noOperationSuffix: false },
  { url: '/12', label: 'Edit Payroll Group', operationName: 'Ocean Import', parentUrl: null, closeOnLogout: false, metadata: null, counter: 0, noOperationSuffix: false },
  { url: '/15', label: 'Salesperson List', operationName: 'Ocean Import', parentUrl: null, closeOnLogout: false, metadata: null, counter: 0, noOperationSuffix: false },
  { url: '/16', label: 'New Salesperson', operationName: 'Ocean Import', parentUrl: null, closeOnLogout: false, metadata: null, counter: 0, noOperationSuffix: false },
  { url: '/17', label: 'Edit Salesperson', operationName: 'Ocean Import', parentUrl: null, closeOnLogout: false, metadata: null, counter: 0, noOperationSuffix: false },
  { url: '/18', label: 'Account Code List', operationName: 'Ocean Import', parentUrl: null, closeOnLogout: false, metadata: null, counter: 0, noOperationSuffix: false },
  { url: '/19', label: 'New Account Code', operationName: 'Ocean Import', parentUrl: null, closeOnLogout: false, metadata: null, counter: 0, noOperationSuffix: false },
  { url: '/20', label: 'Edit Account Code', operationName: 'Ocean Import', parentUrl: null, closeOnLogout: false, metadata: null, counter: 0, noOperationSuffix: false },
  { url: '/21', label: 'View Account Code', operationName: 'Ocean Import', parentUrl: null, closeOnLogout: false, metadata: null, counter: 0, noOperationSuffix: false },
  { url: '/22', label: 'Account Sub Code List', operationName: 'Ocean Import', parentUrl: null, closeOnLogout: false, metadata: null, counter: 0, noOperationSuffix: false },
  { url: '/23', label: 'New Account Sub Code', operationName: 'Ocean Import', parentUrl: null, closeOnLogout: false, metadata: null, counter: 0, noOperationSuffix: false },
  { url: '/24', label: 'Edit Account Sub Code', operationName: 'Ocean Import', parentUrl: null, closeOnLogout: false, metadata: null, counter: 0, noOperationSuffix: false },
  { url: '/25', label: 'Billing Code List', operationName: 'Ocean Import', parentUrl: null, closeOnLogout: false, metadata: null, counter: 0, noOperationSuffix: false },
  { url: '/26', label: 'New Billing Code', operationName: 'Ocean Import', parentUrl: null, closeOnLogout: false, metadata: null, counter: 0, noOperationSuffix: false },
  { url: '/27', label: 'Edit Billing Code', operationName: 'Ocean Import', parentUrl: null, closeOnLogout: false, metadata: null, counter: 0, noOperationSuffix: false },
  { url: '/28', label: 'View Billing Code', operationName: 'Ocean Import', parentUrl: null, closeOnLogout: false, metadata: null, counter: 0, noOperationSuffix: false },
  { url: '/29', label: 'Currency Code List', operationName: 'Ocean Import', parentUrl: null, closeOnLogout: false, metadata: null, counter: 0, noOperationSuffix: false },
  { url: '/30', label: 'New Currency Code', operationName: 'Ocean Import', parentUrl: null, closeOnLogout: false, metadata: null, counter: 0, noOperationSuffix: false },
  { url: '/31', label: 'Edit Currency Code', operationName: 'Ocean Import', parentUrl: null, closeOnLogout: false, metadata: null, counter: 0, noOperationSuffix: false },
  { url: '/32', label: 'View Currency Code', operationName: 'Ocean Import', parentUrl: null, closeOnLogout: false, metadata: null, counter: 0, noOperationSuffix: false },
  { url: '/33', label: 'Airline Code List', operationName: 'Ocean Import', parentUrl: null, closeOnLogout: false, metadata: null, counter: 0, noOperationSuffix: false },
  { url: '/34', label: 'New Airline Code', operationName: 'Ocean Import', parentUrl: null, closeOnLogout: false, metadata: null, counter: 0, noOperationSuffix: false },
  { url: '/35', label: 'Edit Airline Code', operationName: 'Ocean Import', parentUrl: null, closeOnLogout: false, metadata: null, counter: 0, noOperationSuffix: false },
  { url: '/36', label: 'View Airline Code', operationName: 'Ocean Import', parentUrl: null, closeOnLogout: false, metadata: null, counter: 0, noOperationSuffix: false },
  { url: '/37', label: 'Airport Code List', operationName: 'Ocean Import', parentUrl: null, closeOnLogout: false, metadata: null, counter: 0, noOperationSuffix: false },
  { url: '/38', label: 'New Airport Code', operationName: 'Ocean Import', parentUrl: null, closeOnLogout: false, metadata: null, counter: 0, noOperationSuffix: false },
  { url: '/39', label: 'Edit Airport Code', operationName: 'Ocean Import', parentUrl: null, closeOnLogout: false, metadata: null, counter: 0, noOperationSuffix: false },
  { url: '/40', label: 'B/L Type List', operationName: 'Ocean Import', parentUrl: null, closeOnLogout: false, metadata: null, counter: 0, noOperationSuffix: false },
  { url: '/41', label: 'New B/L Type', operationName: 'Ocean Import', parentUrl: null, closeOnLogout: false, metadata: null, counter: 0, noOperationSuffix: false },
  { url: '/42', label: 'Edit B/L Type', operationName: 'Ocean Import', parentUrl: null, closeOnLogout: false, metadata: null, counter: 0, noOperationSuffix: false },
  { url: '/43', label: 'Container Type List', operationName: 'Ocean Import', parentUrl: null, closeOnLogout: false, metadata: null, counter: 0, noOperationSuffix: false },
  { url: '/44', label: 'New Container Type',  operationName: 'Ocean Import', parentUrl: null, closeOnLogout: false, metadata: null, counter: 0, noOperationSuffix: false },
  { url: '/45', label: 'Edit Container Type', operationName: 'Ocean Import', parentUrl: null, closeOnLogout: false, metadata: null, counter: 0, noOperationSuffix: false },
  { url: '/46', label: 'View Container Type', operationName: 'Ocean Import', parentUrl: null, closeOnLogout: false, metadata: null, counter: 0, noOperationSuffix: false },
  { url: '/47', label: 'Move Type List', operationName: 'Ocean Import', parentUrl: null, closeOnLogout: false, metadata: null, counter: 0, noOperationSuffix: false },
  { url: '/48', label: 'New Move Type', operationName: 'Ocean Import', parentUrl: null, closeOnLogout: false, metadata: null, counter: 0, noOperationSuffix: false },
  { url: '/49', label: 'Edit Move Type', operationName: 'Ocean Import', parentUrl: null, closeOnLogout: false, metadata: null, counter: 0, noOperationSuffix: false },
  { url: '/50', label: 'Port Code(Sch D&K) List', operationName: 'Ocean Import', parentUrl: null, closeOnLogout: false, metadata: null, counter: 0, noOperationSuffix: false },
  { url: '/51', label: 'New Port Code(Sch D&K)', operationName: 'Ocean Import', parentUrl: null, closeOnLogout: false, metadata: null, counter: 0, noOperationSuffix: false },
  { url: '/52', label: 'Edit Port Code(Sch D&K)', operationName: 'Ocean Import', parentUrl: null, closeOnLogout: false, metadata: null, counter: 0, noOperationSuffix: false },
  { url: '/53', label: 'Vessel Name List', operationName: 'Ocean Import', parentUrl: null, closeOnLogout: false, metadata: null, counter: 0, noOperationSuffix: false },
  { url: '/54', label: 'New Vessel Name', operationName: 'Ocean Import', parentUrl: null, closeOnLogout: false, metadata: null, counter: 0, noOperationSuffix: false },
  { url: '/55', label: 'Edit Vessel Name', operationName: 'Ocean Import', parentUrl: null, closeOnLogout: false, metadata: null, counter: 0, noOperationSuffix: false },
  { url: '/56', label: 'SCAC Code List', operationName: 'Ocean Import', parentUrl: null, closeOnLogout: false, metadata: null, counter: 0, noOperationSuffix: false },
  { url: '/57', label: 'New SCAC Code', operationName: 'Ocean Import', parentUrl: null, closeOnLogout: false, metadata: null, counter: 0, noOperationSuffix: false },
  { url: '/58', label: 'Edit SCAC Code', operationName: 'Ocean Import', parentUrl: null, closeOnLogout: false, metadata: null, counter: 0, noOperationSuffix: false },
  { url: '/59', label: 'View SCAC Code', operationName: 'Ocean Import', parentUrl: null, closeOnLogout: false, metadata: null, counter: 0, noOperationSuffix: false },
  { url: '/60', label: 'Country Code List', operationName: 'Ocean Import', parentUrl: null, closeOnLogout: false, metadata: null, counter: 0, noOperationSuffix: false },
  { url: '/61', label: 'New Country Code', operationName: 'Ocean Import', parentUrl: null, closeOnLogout: false, metadata: null, counter: 0, noOperationSuffix: false },
  { url: '/62', label: 'Edit Country Code', operationName: 'Ocean Import', parentUrl: null, closeOnLogout: false, metadata: null, counter: 0, noOperationSuffix: false },
  { url: '/63', label: 'State Code List', operationName: 'Ocean Import', parentUrl: null, closeOnLogout: false, metadata: null, counter: 0, noOperationSuffix: false },
  { url: '/64', label: 'New State Code', operationName: 'Ocean Import', parentUrl: null, closeOnLogout: false, metadata: null, counter: 0, noOperationSuffix: false },
  { url: '/65', label: 'Edit State Code', operationName: 'Ocean Import', parentUrl: null, closeOnLogout: false, metadata: null, counter: 0, noOperationSuffix: false },
  { url: '/66', label: 'UN Location Code List', operationName: 'Ocean Import', parentUrl: null, closeOnLogout: false, metadata: null, counter: 0, noOperationSuffix: false },
  { url: '/67', label: 'New UN Location Code', operationName: 'Ocean Import', parentUrl: null, closeOnLogout: false, metadata: null, counter: 0, noOperationSuffix: false },
  { url: '/68', label: 'Edit UN Location Code', operationName: 'Ocean Import', parentUrl: null, closeOnLogout: false, metadata: null, counter: 0, noOperationSuffix: false },
  { url: '/69', label: 'View UN Location Code', operationName: 'Ocean Import', parentUrl: null, closeOnLogout: false, metadata: null, counter: 0, noOperationSuffix: false },
  { url: '/70', label: 'Export Info Code List', operationName: 'Ocean Import', parentUrl: null, closeOnLogout: false, metadata: null, counter: 0, noOperationSuffix: false },
  { url: '/71', label: 'New Export Info Code', operationName: 'Ocean Import', parentUrl: null, closeOnLogout: false, metadata: null, counter: 0, noOperationSuffix: false },
  { url: '/72', label: 'Edit Export Info Code', operationName: 'Ocean Import', parentUrl: null, closeOnLogout: false, metadata: null, counter: 0, noOperationSuffix: false },
  { url: '/73', label: 'Export License Code List', operationName: 'Ocean Import', parentUrl: null, closeOnLogout: false, metadata: null, counter: 0, noOperationSuffix: false },
  { url: '/74', label: 'New Export License Code', operationName: 'Ocean Import', parentUrl: null, closeOnLogout: false, metadata: null, counter: 0, noOperationSuffix: false },
  { url: '/75', label: 'Edit Export License Code', operationName: 'Ocean Import', parentUrl: null, closeOnLogout: false, metadata: null, counter: 0, noOperationSuffix: false },
  { url: '/76', label: 'Schedule B Code List', operationName: 'Ocean Import', parentUrl: null, closeOnLogout: false, metadata: null, counter: 0, noOperationSuffix: false },
  { url: '/77', label: 'New Schedule B Code', operationName: 'Ocean Import', parentUrl: null, closeOnLogout: false, metadata: null, counter: 0, noOperationSuffix: false },
  { url: '/78', label: 'Edit Schedule B Code', operationName: 'Ocean Import', parentUrl: null, closeOnLogout: false, metadata: null, counter: 0, noOperationSuffix: false },
  { url: '/79', label: 'A/N Title List', operationName: 'Ocean Import', parentUrl: null, closeOnLogout: false, metadata: null, counter: 0, noOperationSuffix: false },
  { url: '/80', label: 'New A/N Title', operationName: 'Ocean Import', parentUrl: null, closeOnLogout: false, metadata: null, counter: 0, noOperationSuffix: false },
  { url: '/81', label: 'Edit A/N Title', operationName: 'Ocean Import', parentUrl: null, closeOnLogout: false, metadata: null, counter: 0, noOperationSuffix: false },
  { url: '/82', label: 'Commodity Code List', operationName: 'Ocean Import', parentUrl: null, closeOnLogout: false, metadata: null, counter: 0, noOperationSuffix: false },
  { url: '/83', label: 'New Commodity Code', operationName: 'Ocean Import', parentUrl: null, closeOnLogout: false, metadata: null, counter: 0, noOperationSuffix: false },
  { url: '/84', label: 'Edit Commodity Code', operationName: 'Ocean Import', parentUrl: null, closeOnLogout: false, metadata: null, counter: 0, noOperationSuffix: false },
  { url: '/85', label: 'EDI315 Code List', operationName: 'Ocean Import', parentUrl: null, closeOnLogout: false, metadata: null, counter: 0, noOperationSuffix: false },
  { url: '/86', label: 'New EDI315 Code', operationName: 'Ocean Import', parentUrl: null, closeOnLogout: false, metadata: null, counter: 0, noOperationSuffix: false },
  { url: '/87', label: 'Edit EDI315 Code', operationName: 'Ocean Import', parentUrl: null, closeOnLogout: false, metadata: null, counter: 0, noOperationSuffix: false },
  { url: '/88', label: 'Line Code List', operationName: 'Ocean Import', parentUrl: null, closeOnLogout: false, metadata: null, counter: 0, noOperationSuffix: false },
  { url: '/89', label: 'New Line Code', operationName: 'Ocean Import', parentUrl: null, closeOnLogout: false, metadata: null, counter: 0, noOperationSuffix: false },
  { url: '/91', label: 'Edit Line Code', operationName: 'Ocean Import', parentUrl: null, closeOnLogout: false, metadata: null, counter: 0, noOperationSuffix: false },
  { url: '/92', label: 'View Line Code', operationName: 'Ocean Import', parentUrl: null, closeOnLogout: false, metadata: null, counter: 0, noOperationSuffix: false },
  { url: '/93', label: 'Memo Title List', operationName: 'Ocean Import', parentUrl: null, closeOnLogout: false, metadata: null, counter: 0, noOperationSuffix: false },
  { url: '/94', label: 'New Memo Title', operationName: 'Ocean Import', parentUrl: null, closeOnLogout: false, metadata: null, counter: 0, noOperationSuffix: false },
  { url: '/95', label: 'Edit Memo Title', operationName: 'Ocean Import', parentUrl: null, closeOnLogout: false, metadata: null, counter: 0, noOperationSuffix: false },
  { url: '/96', label: 'Other Shipment Type List', operationName: 'Ocean Import', parentUrl: null, closeOnLogout: false, metadata: null, counter: 0, noOperationSuffix: false },
  { url: '/97', label: 'New Other Shipment Type', operationName: 'Ocean Import', parentUrl: null, closeOnLogout: false, metadata: null, counter: 0, noOperationSuffix: false },
  { url: '/98', label: 'Edit Other Shipment Type', operationName: 'Ocean Import', parentUrl: null, closeOnLogout: false, metadata: null, counter: 0, noOperationSuffix: false },
];

const buttonWidth = 165; // 160 px button + 5px space between

function getActualWidths(renderingButtonCount: number, screenWidth: number, isHome: boolean) {
  const buttonCount = renderingButtonCount;

  const actualWidth = !isHome 
  ? screenWidth - 60 // Calculate 20px padding left, 20px padding right and scrollbar 20px
  : screenWidth - 40; // Calculate 20px padding left, 20px padding right
  const scrollControlsWidth = 205;

  // let batchSize = Math.floor((actualWidth - scrollControlsWidth) / buttonWidth);

  // const showScrollbars = buttonCount > batchSize;

  // const maxScrollPositions = buttonCount - batchSize; // Buttons shown initially don't scroll

  return {
    buttonCount,
    actualWidth,
    buttonWidth,
    scrollControlsWidth,
    // batchSize,
    // showScrollbars,
    // maxScrollPositions
  };
}

type JobSwitchingMenuProps = {
  testMode: boolean,
  resetJobMenuContextState: VoidFunction,
};

const JobSwitchingMenu: React.FC<JobSwitchingMenuProps> = ({ testMode, resetJobMenuContextState }) => {
  const chkChannel = postal.channel('ifms');
  const channel = postal.channel('ajax');
  
  const context = useContext(JobSwitchingMenuContext);
  const appContext = useContext(ApplicationContext);

  const useDarkMode = appContext.useDarkMode;
  
  const [showGlobalYesNoDialog] = useGlobalYesNoDialog();
  
  const history = useHistory();
  const dispatch = useAppDispatch();
  const { getSingleOpenedScreenInAnyOperationStartingWithUrl } = useJobMenus();

  const [referenceElement, setReferenceElement] = useState<HTMLSpanElement|null>(null);
  const [popperElement, setPopperElement] = useState<HTMLDivElement|null>(null);
  const [arrowElement, setArrowElement] = useState<HTMLDivElement|null>(null);
  const { styles, attributes } = usePopper(referenceElement, popperElement, {
    modifiers: [{ name: 'arrow', options: { element: arrowElement } },],
    placement: 'bottom-end',
  });
  const [mouseOverBtnNum, setMouseOverBtnNum] = useState(-1);

  const [screenWidth] = useWindowSize();
  const [currentScrollPosition, setCurrentScrollPosition] = useState<number>(0);
  const [menuHelperVisible, _setMenuHelperVisible] = useState<boolean>(false);
  
  const [visibleWidth, setVisibleWidth] = useState<number>(0);
  const [beforeActualWidth, setBeforeActualWidth] = useState<number>(0);
  const [beforeTotalWidth, setBeforeTotalWidth] = useState<number>(0);
  const [currentLeft, setCurrentLeft] = useState<number>(0);
  const jobMenu = useAppSelector(state => state.jobMenu);
  const operationState = useAppSelector(state => state.operation);
  const operation = operationState.operation;
  const storage = useAppSelector(x => x.storage);

  const isStandaloneOperation = operation === constants.operations.standalone;
  // const isCustomerOperation = operation === constants.operations.customer;

  const {removeSingleJobMenu, goBackSingle} = useJobMenus();
  const getExternalFunctions = useFunction({
    callbacks: ['ifmsSettingsSave', 'ifmsSettingsCancel','ifmsReferenceFilesSave', 'ifmsReferenceFilesCancel']
  });
  
  let operationKey = getOperationKey(operation);
  if (!operationKey) {
    if (operation === 'Reference Files' || operation === 'Settings') {
    //    if (operation === 'Reference Files' || operation === 'Settings' || operation === 'Utilities') {
      operationKey = getOperationKey('Standalone');
    }
  }
  /*const jobMenuItems = !!operationKey
    ? (isStandaloneOperation ? [jobMenu[operationKey][jobMenu[operationKey].length - 1]] : jobMenu[operationKey])
    : [];*/

    const jobMenuItems = !!operationKey
    ? Object.keys(jobMenu)
        .flatMap(opKey => jobMenu[opKey].map(item => {
          const op = getOpByName(opKey);
          let suffixlabel = '';
          if(op && !item.noOperationSuffix && item.jobType && !!item.addTypeSuffix){
            suffixlabel = `(${op} ${item.jobType})`;
          } else if (op && !item.noOperationSuffix){
            suffixlabel=`(${op})`;
          } else if (item.jobType && !!item.addTypeSuffix){
            suffixlabel = `(${item.jobType})`;
          }
          return {
            ...item,
            label: `${item.label} ${suffixlabel}`,
          };
        }))
        .sort((a, b) => {
          if (a?.timestamp === b?.timestamp) {
            return 0;
          } else {
            return a?.timestamp! > b?.timestamp! ? 1 : -1;
          }
        })
    : [];

  function isScreenDirty(urlParam: string): boolean {
    let result = false;

    //const url = !urlParam.includes('common/joblistview') ? getRoutePath(urlParam) : urlParam;

    _.mapKeys(fastStorage, (val, key) => {
      if (result) {
        return;
      }

      //if (!key.endsWith(url)) {
      if (!key.endsWith(urlParam)) {
        return;
      }

      if (val && val.isDirty !== undefined && val.isDirty === true) {
        result = true;
      }
    })

    return result;
  }

  async function checkStandaloneDirty() {
    if(operationState.operation !== 'Standalone') return;
    
    if (fastStorage['ifms-settings-haschanges']) {
      const doSave = await showGlobalYesNoDialog(
        <div>
          There are unsaved changes. Do you want to save?
        </div>
      ,false, 1, true, 'info');

      const externalFunctions = getExternalFunctions();
      if (doSave) {
        await externalFunctions.ifmsSettingsSave();
      } else {
        await externalFunctions.ifmsSettingsCancel();
      }
    }
    else if (fastStorage['ifms-referenceFiles-haschanges']) {
      const doSave = await showGlobalYesNoDialog(
        <div>
          There are unsaved changes. Do you want to save?
        </div>
      ,false, 1, true, 'info');

      const externalFunctions = getExternalFunctions();
      if (doSave) {
        await externalFunctions.ifmsReferenceFilesSave();
      } else {
        await externalFunctions.ifmsReferenceFilesCancel();
      }
    }
  }

  async function executeJobMenu(j: JobMenuItem) {
    await checkStandaloneDirty();

    resetJobMenuContextState();

    let afterScreenUrl = j.afterScreenUrl;
    if (j.url) {
      if (context.isHome) {
        dispatch(changeSideMenu('Home'));
        dispatch(changeOperation('Home'));
      }

      if (operationKey) {
        if (['invoice/view', 'bill/view', 'crdb/view', 'periodInvoice/view'].some(x=> j.url.indexOf(x) >= 0)) {
          const lastScreenQuery = getSingleOpenedScreenInAnyOperationStartingWithUrl(j.url);
          if (lastScreenQuery && lastScreenQuery.item) {
            afterScreenUrl = lastScreenQuery.operation;
          }
        }

        dispatch(moveScreenToTop({
          url: j.url,
          operation: afterScreenUrl??operationKey,
        }));
      }
      openNewPage(history, j.url, NavigationType.jobMenuSwitch, j.metadata, afterScreenUrl);
    }
  }

  const allItems:Array<JobMenuItem> = testMode ? testJobMenu : jobMenuItems;
  // Hide home menu
  // const [/*homeJobMenu*/, ...renderingJobMenuItems] = allItems; // Home button is always first and should always be visible
  const [...renderingJobMenuItems] = allItems; // Home button is no longer visible
  const [menuItemCount, setMenuItemCount] = useState<number>(renderingJobMenuItems.length);   // [menu-tab-scroll]
  if (menuItemCount !== jobMenuItems.length)
    setMenuItemCount(jobMenuItems.length);

  // const width = screenWidth - buttonWidth; // Home button is by itself
  const width = !context.isHome ? screenWidth - IfmsSideMenuWidthNumber : screenWidth;

  const buttonsRef = useRef<HTMLDivElement>(null);
  const openRef = useRef(false);

  const menuContainerRef = useRef<HTMLDivElement>(null);
  const sizes = getActualWidths(renderingJobMenuItems.length, width, context.isHome);

  let visibleTabWidth = 0;
  let batchSize = 0;

  const btnList = document.getElementsByClassName('ifms-job-btn-container');

  for (let i = 0; i < btnList.length; i++) {
    visibleTabWidth += btnList[i].clientWidth + 5;

    if ((sizes.actualWidth - sizes.scrollControlsWidth) < visibleTabWidth) {
      batchSize = i;
      visibleTabWidth -= (btnList[i].clientWidth + 5);
      break;
    }
  }

  if (batchSize === 0 && sizes.actualWidth - sizes.scrollControlsWidth > 0) {
    batchSize = Math.floor((sizes.actualWidth - sizes.scrollControlsWidth) / buttonWidth);
    visibleTabWidth = buttonWidth * batchSize;
    // setVisibleWidth(visibleTabWidth);
  }

  const maxScrollPositions = renderingJobMenuItems.length - batchSize;

  useEffect(() => {
    setMouseOverBtnNum(-1);
  }, [history.location.pathname])

  if (isStandaloneOperation) {
    if (jobMenuItems.length > 0) {
      const standaloneTitle:string = jobMenuItems[0].label;
      chkChannel.publish('ifms.standalone-title', standaloneTitle);
    }
  }

  const activeIndexInView = allItems.findIndex(j => `${history.location.pathname}${history.location.search}` === j.url);

  useEffect(() => {
    if (activeIndexInView >= 0) {
      scrollJobMenuItemIntoView({
        ...renderingJobMenuItems[activeIndexInView],
        index: activeIndexInView
      });
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeIndexInView, width, menuItemCount, screenWidth, buttonsRef.current]);

  function setMenuHelperVisible(v:boolean) {
    openRef.current = v;
    _setMenuHelperVisible(v);
  }

  function scrollJobMenuItemIntoView(j: JobMenuItemWithIndex) {
    if (!buttonsRef || !buttonsRef.current) {
      return;
    }
    
    const totalTabWidth = _.sumBy(btnList, function (b) { return b.clientWidth + 5; });

    const indexInScrollView = j.index;
    const visibleIndexFrom = currentScrollPosition;
    let visibleIndexTo = currentScrollPosition + batchSize - 1;

    if (beforeActualWidth === sizes.actualWidth && beforeTotalWidth === totalTabWidth && indexInScrollView >= visibleIndexFrom && indexInScrollView <= visibleIndexTo) {
      if(currentScrollPosition !== 0){
        buttonsRef.current.scrollTo({
          top: 0,
          left: currentLeft,
          behavior: 'smooth'
        });
      } 
      else
        return;
    }

    if (beforeTotalWidth !== totalTabWidth) {
      setBeforeTotalWidth(totalTabWidth);
    }

    if (beforeActualWidth !== sizes.actualWidth) {
      setBeforeActualWidth(sizes.actualWidth);
    }

    visibleTabWidth = 0;
    let startIndex = 0;
    let scrollDelta = 0;

    for (let i = startIndex; i < btnList.length; i++) {
      visibleTabWidth += btnList[i].clientWidth + 5;

      if ((sizes.actualWidth - sizes.scrollControlsWidth) < visibleTabWidth) {
        if (indexInScrollView <= i - 1) {
          batchSize = i;
          visibleTabWidth = sizes.actualWidth - sizes.scrollControlsWidth;
          visibleIndexTo = currentScrollPosition + batchSize - 1;
          break;
        } else {
          i = startIndex++;
          visibleTabWidth = 0;
          if(startIndex > currentScrollPosition) scrollDelta++;
        }
      }
    }

    if (btnList.length - currentScrollPosition < batchSize) {
      let currentVisibleTabWidth = 0;

      for (let i = visibleIndexFrom; i < (visibleIndexTo > btnList.length ? btnList.length : visibleIndexTo); i++) {
        currentVisibleTabWidth += btnList[i].clientWidth + 5;
      }

      if (currentVisibleTabWidth <= (sizes.actualWidth - sizes.scrollControlsWidth)) {
        for (let i = (visibleIndexFrom - 1); i >= 0; i--) {
          currentVisibleTabWidth += btnList[i].clientWidth + 5;

          if (currentVisibleTabWidth <= (sizes.actualWidth - sizes.scrollControlsWidth)) {
            scrollDelta--;
          } else {
            break;
          }
        }
      }
    }

    if (indexInScrollView > visibleIndexTo) {//현재 보이는것보다 우측에 있을 경우
      scrollDelta = indexInScrollView - visibleIndexTo;
    } else if (indexInScrollView < visibleIndexFrom) { //현재 보이는 것보다 좌측에 있는 경우
      //음수로 만들어 계산식으로 하나로 통일
      scrollDelta = indexInScrollView - visibleIndexFrom;
    }

    const newScrollPosition = currentScrollPosition + scrollDelta;

    let newLeft = 0;

    for (let i = 0; i < newScrollPosition; i++) {
      newLeft += btnList[i].clientWidth + 5;
    }

    if (newLeft !== currentLeft) {
      buttonsRef.current.scrollTo({
        top: 0,
        left: newLeft,
        behavior: 'smooth'
      });

      setCurrentLeft(newLeft);
    }

    setVisibleWidth(visibleTabWidth);
    setCurrentScrollPosition(newScrollPosition);
  }

  function jobMenuSelectedFromHelperMenu(j:IfmsMenuItem) {
    setMenuHelperVisible(false);
    if (j && j.job) {
      executeJobMenu(j.job);
    }
    j.job.index = j.index;
    scrollJobMenuItemIntoView(j.job);
  }

  function scrollRight() {
    if (!buttonsRef || !buttonsRef.current) {
      return;
    }

    if (currentScrollPosition >= maxScrollPositions) {
      return;
    }

    let newLeft = 0;

    for (let i = 0; i < currentScrollPosition + 1; i++) {
      newLeft += btnList[i].clientWidth + 5;
    }

    const newScrollPosition = currentScrollPosition + 1;

    buttonsRef.current.scrollTo({
      top: 0,
      left: newLeft,
      // left: btnList[currentScrollPosition].clientWidth + 5,
      behavior: 'smooth'
    });
    setCurrentLeft(newLeft);
    setCurrentScrollPosition(newScrollPosition);
  }

  function scrollLeft() {
    if (!buttonsRef || !buttonsRef.current) {
      return;
    }

    if (currentScrollPosition <= 0) {
      return;
    }

    let newLeft = 0;

    for (let i = 0; i < currentScrollPosition - 1; i++) {
      newLeft += btnList[i].clientWidth + 5;
    }

    const newScrollPosition = currentScrollPosition - 1;

    buttonsRef.current.scrollTo({
      top: 0,
      left: newLeft,
      behavior: 'smooth'
    });
    setCurrentLeft(newLeft);
    setCurrentScrollPosition(newScrollPosition);

    const totalTabWidth = _.sumBy(btnList, function (b) { return b.clientWidth + 5; });
    if(totalTabWidth > visibleWidth) {
      setVisibleWidth(sizes.actualWidth - sizes.scrollControlsWidth);
    }
  }
  
  async function purgeLocalStorage() {
    const keys = await localforage.keys();
    const toDelete = keys.filter(k => k.startsWith('filter-'));

    for (const key of toDelete) {
      await localforage.removeItem(key);
    }

    const keysToRemove = Object.keys(fastStorage).filter(k => (
      k.startsWith('filter-') || 
      k.startsWith('ifms-list-data-') ||
      k.includes('referenceFiles') ||
      k.includes('settings')
    ));
    
    keysToRemove.forEach(k => delete fastStorage[k]);
  }

  async function resetScreens(e: SyntheticEvent) {
    function distinct(value:JobMenuItem, index:number, self:Array<JobMenuItem>) {
      return self.findIndex(x => stringsEqualIgnoreCase(x.url, value.url)) === index;
    }

    const allJobMenuItems = [
      ...jobMenu.home,
      ...jobMenu.oceanImport,
      ...jobMenu.oceanExport,
      ...jobMenu.airImport,
      ...jobMenu.airExport,
      ...jobMenu.otherShipment,
      ...jobMenu.whReceipt,
      ...jobMenu.accounting,
      ...jobMenu.warehousing,
      ...jobMenu.opReport,
      ...jobMenu.customer,
      ...jobMenu.standalone,
      ...jobMenu.utility,
      ...jobMenu.billings,
      // ...jobMenu.brokerageTrucking,
      ...jobMenu.order,
      ...jobMenu.load,
      ...jobMenu.localDO,
      ...jobMenu.myEvent,
      ...jobMenu.businessIntell,
      ...jobMenu.orchidBaro,
      ...jobMenu.ams,
      ...jobMenu.isf
    ].filter(x => !stringsEqualIgnoreCase('Home', x.label)).filter(distinct)

    const jobMenuItemsToClose = allJobMenuItems.filter(x => !x.jobMode || x.jobMode === 'view');
    let doClose = false;

    if (jobMenuItemsToClose.length > 0) {
      doClose = await showGlobalYesNoDialog(
        <div>
          <h3>Are you sure you want to close all tabs except edit and new view?</h3>

          {/* There are opened screens:
          <br />
          <br />
          {jobMenuItemsToClose.map((x, i) => (
            <li key={i}>{x.label}</li>
          ))} */}
        </div>
      ,false, 0, true);
    }

    if (doClose) {
      channel.publish('ajax.loadingstart', {});
      await purgeLocalStorage();

      jobMenuItemsToClose.forEach(async x => {
        setCurrentScrollPosition(0);
        await closeJobMenuTab(e, x.url, x.operationName || '', false);
      });
      const exceptedJobMenuItems = allJobMenuItems
        .filter(x => x.jobMode && x.jobMode !== 'view')
        .sort((a, b) => {
          const timeA = new Date(a.timestamp ?? '').getTime();
          const timeB = new Date(b.timestamp ?? '').getTime();
          return timeA - timeB;
        });

      if (exceptedJobMenuItems.length > 0)
        executeJobMenu(exceptedJobMenuItems[exceptedJobMenuItems.length - 1])
      else {
        dispatch(clearStorage());
        dispatch(clearOperation());
        dispatch(resetListScreenSettings());
        dispatch(clearLastSavedJobs());
        history.push('/');
        openNewPage(history, '/home/home', NavigationType.newPage);
      }
      channel.publish('ajax.loadingend', {});
    }
  }



  function resetSearch(isActiveMenu: boolean) {
    return (
      <FontAwesomeIcon color={'orange'} icon={faFilter} />
    )
  }


  function renderValue(x: any) {
    let result = ''

    if (x.type === 'bool')
      result = x.value ? 'Checked' : 'Unchecked';
    else if (x.type === 'date')
      result = renderDateRangeValue(x);
    else
      result = x.value === null ? '' : x.value

    return result;
  }
  
  function renderDateRangeValue(x: any) {
    const parts = x.value ? x.value.split('~') : [];
    const from = parts.length > 0 ? formatDate(parts[0].trim()) : '';
    const to = parts.length > 1 ? formatDate(parts[1].trim()) : '';

    return `${formatDate(from)} ~ ${formatDate(to)}`;
  }

  function getJobMenuLabel(j:JobMenuItem, index:number) {
    if (!j || !j.url) return;
    // In case job menu represents list screen, and list screen has filtering applied, add additional icon to the label
    // In case filter is external set (F6 for example MBL -> HBL), treat it as no filter
    let filter = <></>;
     
    const otherStorageKey = `filter-${FilterStorageVersion}-${j.url}`;
    const screenFilter = storage[otherStorageKey];

       // operationKey가 'standalone'인 경우 Filter 버튼은 내부 Tab 별로 그려줌
      if ((!isFilterObjectEmpty(screenFilter) || screenFilter?.isSearchByReport) && j.operationName !== 'Standalone' || screenFilter?.listType > 0 ||screenFilter?.listType2 > 0) {
      filter = <div style={{ float: 'left' }}>
        <TooltipButton
          jobMenuLabel={j.label}
          jobMenuMetadata={j.metadata}
          jobMenuUrl={j.url}
          screenFilter={screenFilter}
          isActiveMenu={`${history.location.pathname}${history.location.search}` === j.url}>
        </TooltipButton>
      </div>;
    }

    return (
      <div style={{ width: '100%', height: '20px', display: 'flex', alignItems: 'center' }}>
        <div style={{ width: '100%', float: 'left', marginLeft: '5px', marginRight: '5px', minWidth: '99px' }}>
          <span>{j.label}</span>
        </div>
        {filter}

        {j.url !== '/home/home' && (
          <div id={`job-menu-close-${j.label.replace(/ /g, '')}`} className='ifms-job-btn-close-wrapper' onClick={(e) => closeJobMenuTab(e, j.url, j.operationName || '', true, j.jobMode)}>
            <img style={{ width: '18px' }} src={mouseOverBtnNum === index ? circleExitWhite : circleExitRed} alt='' />
          </div>
        )}
      </div>
    );
  }
  
  function getJobMenuInactiveClass(j:JobMenuItem) {
    return !!j.operationName ? `${!useDarkMode ? 'e-job-btn-inactive' : 'e-job-btn-inactive-darkmode'}` : 'e-job-btn-common-inactive';
  }

  function getJobMenuActiveClass(j:JobMenuItem) {
    return !!j.operationName ? `${!useDarkMode ? 'e-job-btn-active' : 'e-job-btn-active-darkmode'}` : 'e-job-btn-common-active';
  }
  
  function getJobMenuClass(j:JobMenuItem) {
    return `e-ifms-jsmbtn e-job-btn ${`${history.location.pathname}${history.location.search}` !== j.url ? getJobMenuInactiveClass(j) : getJobMenuActiveClass(j)}`;
  }

  const appliedPopperStyles:React.CSSProperties = {
    ...styles.popper,
    minWidth: '150px',
    paddingTop: 10,
  };

  // if (sizes.actualWidth < (sizes.buttonWidth + sizes.scrollControlsWidth)) {
  if (sizes.actualWidth < (btnList[0]?.clientWidth + sizes.scrollControlsWidth)) {
    // There is not enough space for this control. Don't render it
    return null;
  }

  const closeJobMenuTab = async (e: SyntheticEvent, url: string, urlOperation: string, needGoBack: boolean = true, jobMode: string = '') => {
    e.stopPropagation();
    if(!jobMode || jobMode !=='view' ){
      if (isScreenDirty(url) ) {
        const doClose = await showGlobalYesNoDialog(
          <div>
            <h3>Confirm to Close without saving?</h3>
          </div>
        , false, 0, true);
  
        if (!doClose) {
          return;
        }
      }
    }
    // appContext.setJournalType(0);
    if (url.includes('/common/joblistview/btLoadPlan/load')) {
      const keyMatch = _.keys(fastStorage).find(x => x.startsWith('BTLoadPlan-ListFilter'));
      if (keyMatch) {
        delete fastStorage[keyMatch];
      }
    }
    else if (url.includes('/common/joblistview/btOrder/order')) {
      const keyMatch = _.keys(fastStorage).find(x => x.startsWith('BTOrder-ListFilter'));
      if (keyMatch) {
        delete fastStorage[keyMatch];
      }
    }
    
    else if (url.includes('/common/joblistview/btLocalDO/localDO')) {
      const keyMatch = _.keys(fastStorage).find(x => x.startsWith('BTDo-ListFilter'));
      if (keyMatch) {
        delete fastStorage[keyMatch];
      }
    }

    else if (url.includes('/common/joblistview/OCBO/orchidBaro')) {
      const keyMatch = _.keys(fastStorage).find(x => x.startsWith('OrchidBaro-ListFilter'));
      if (keyMatch) {
        delete fastStorage[keyMatch];
      }
      const keyMatch2 = _.keys(fastStorage).find(x => x.startsWith('OrchidBaro-status-ListFilter'));
      if (keyMatch2) {
        delete fastStorage[keyMatch2];
      }
    }

    resetJobMenuContextState();

    if(url === `${history.location.pathname}${history.location.search}` && needGoBack) {
      await goBackSingle(url, urlOperation)
    }else{
      removeSingleJobMenu(url, urlOperation);
    }
  }

  // const isHomeLocation = `${history.location.pathname}${history.location.search}` === '/home/home';

  // if (context.isHome) {
  //   // Return empty
  //   return null;
  // }

  const disableJobSwitcgRightBtn = currentScrollPosition >= maxScrollPositions;
  const disableJobSwitcgLeftBtn = currentScrollPosition <= 0;

  let jobSwitchingMenuClassName = !useDarkMode ? 'ifms-job-switching-menu' : 'ifms-job-switching-menu-darkmode';
  if(context.isHome) jobSwitchingMenuClassName += ' ifms-job-switching-homemenu';

  return (
    <div id={`${!useDarkMode ? 'ifms-job-switching-menu-master-container' : 'ifms-job-switching-menu-master-container-darkmode'}`}>
      <div className={jobSwitchingMenuClassName}>
        <div ref={buttonsRef} id="ifms-job-menu-link-buttons-container" style={{ width: visibleWidth, overflow: 'hidden' }}>
          <div id="ifms-job-menu-link-buttons">
            {renderingJobMenuItems.map((j, index) => 
              <div className="ifms-job-btn-container" key={j.url}>
                <div style={{paddingTop:'2px'}} className={getJobMenuClass(j)} id={`job-menu-${j.label.replace(/ /g ,'')}`}  onMouseEnter={() => { setMouseOverBtnNum(index) }} onMouseLeave={() => { setMouseOverBtnNum(-1) }}  onClick={() => executeJobMenu(j)}>
                {getJobMenuLabel(j, index)}
                </div>
              </div>
            )} 
          </div>
        </div>

        {/* {sizes.showScrollbars && */}
        {/* <div id="ifms-job-menu-controls" style={{ minWidth: '105px', paddingLeft: '20px' }}> */}
        {/* Total width of scroll buttons = 5(left padding) + 30(left arrow) + 30 (right arrow) + 25(tab list) => 90 */}
        <div id="ifms-job-menu-controls">
          {/* <img id="closeAllTab" onClick={e => { resetScreens(e) }} height="25px" width='40px' src={closeAllTabIcon} alt="Close All Tabs" data-tooltip="Close All Tabs" style={{ cursor: 'pointer'}} /> */}
          <img id="closeAllTab" onClick={e => { resetScreens(e) }} height="25px" width='40px' src={circleExitRed} alt="Close All Tabs" data-tooltip="Close All Tabs" style={{ cursor: 'pointer'}} />
          
          
          {/* <BlackInverseButton size="small" onClick={scrollLeft} disabled={currentScrollPosition <= 0} style={{ marginRight: '5px', width: '25px' }}>
            <FontAwesomeIcon color='#FF3300' icon={faAngleLeft} />
          </BlackInverseButton> */}

          {/* <250212 jhlee - 스크롤이 필요한 버튼만 표시되도록 변경, src는 투명한 1x1픽셀 이미지 /> */}
          {/* <250226 jhchoi - "<<", ">>" 아이콘 제거 */}
          {/* {disableJobSwitcgLeftBtn ?
            <img height='25px' width='40px' src='data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7' alt='' style={{ border: 0 }} />
            :
            <img onClick={scrollLeft} height='25px' width='40px' src={arrowLeftBlueIcon} style={{ cursor: 'pointer' }} alt='' />
          } */}

          {/* <FontAwesomeIcon
            onClick={scrollLeft}
            style={{ width: '20px', cursor: disableJobSwitcgLeftBtn ? 'default' : 'pointer', marginRight: '10px', marginBottom: '-1px' }}
            size='lg'
            color={disableJobSwitcgLeftBtn ? '#FF3300' : '#0079A4'}
            icon={faAngleLeft} /> */}
          {/* <BlackInverseButton size="small" onClick={scrollRight} disabled={currentScrollPosition >= sizes.maxScrollPositions} style={{marginRight: '5px', width: '25px'}}> */}
          {/* <BlackInverseButton size="small" onClick={scrollRight} disabled={currentScrollPosition >= maxScrollPositions} style={{ marginRight: '5px', width: '25px' }}>
            <FontAwesomeIcon color='#FF3300' icon={faAngleRight} />
          </BlackInverseButton> */}

          {/* <250226 jhchoi - "<<", ">>" 아이콘 제거 */}
          {/* {disableJobSwitcgRightBtn ?
            <img height='25px' width='40px' src='data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7'  alt='' style={{ border: 0 }} />
            :
            <img onClick={scrollRight} height='25px' width='40px' src={arrowRightBlueIcon} style={{ cursor: 'pointer'}} alt='' />
          } */}

          {/* <FontAwesomeIcon
            onClick={scrollRight}
            style={{ width: '20px', cursor: disableJobSwitcgRightBtn ? 'default' : 'pointer', marginRight: '10px', marginBottom: '-1px' }}
            size='lg'
            color={disableJobSwitcgRightBtn ? '#FF3300' : '#0079A4'}
            icon={faAngleRight} /> */}
          {/* <BlackInverseButton
            onMouseEnter={() => setMenuHelperVisible(true)}
            onMouseLeave={() => setMenuHelperVisible(false)}
            size="small"
            onClick={() => setMenuHelperVisible(!menuHelperVisible)}
            style={{ width: '25px', paddingLeft: '0', paddingRight: '0' }}>
            <FontAwesomeIcon color='#FF3300' icon={faListUl} /><span ref={setReferenceElement}></span>
          </BlackInverseButton> */}
          <>
            {/* <FontAwesomeIcon
              onMouseEnter={() => setMenuHelperVisible(true)}
              onMouseLeave={() => setMenuHelperVisible(false)}
              onClick={() => setMenuHelperVisible(!menuHelperVisible)}
              style={{ cursor: 'pointer', paddingTop: '4px', marginBottom: '1px'}}
              size='lg'
              color='#0079A4'
              icon={faListUl}
            /> */}
            <img
              onMouseLeave={() => setMenuHelperVisible(false)}
              onMouseEnter={() => setMenuHelperVisible(true)}
              onClick={scrollRight}
              height="26px"
              width='40px'
              src={tabListIcon}
              style={{ cursor: 'pointer',marginTop:'-1px', }}
              alt=""
            />
            <span ref={setReferenceElement}>
            </span>
          </>
          {menuHelperVisible &&
            <div
              onMouseMove={(e) => { e.stopPropagation() }}
              onMouseEnter={() => setMenuHelperVisible(true)}
              onMouseLeave={() => setMenuHelperVisible(false)}
              ref={setPopperElement} style={appliedPopperStyles} {...attributes.popper}>
              <div ref={menuContainerRef}>
                <Menu
                  specialMenu='jobswitchinghelper'
                  items={[[allItems.map((j, index) => {
                    const btnElement = document.getElementsByClassName("e-ifms-jsmbtn e-job-btn e-job-btn")[index] as HTMLElement;
                    let extraNo = btnElement?.dataset?.tooltip??'';
                    return {
                      text: `${index+1}. ${j.label} ${extraNo ? `(${extraNo})` : ''}`,
                      job: j,
                      selected: `${history.location.pathname}${history.location.search}` === j.url,
                      index,
                    }
                  })]]}
                  // variant='highlight'
                  mode="vertical"
                  onMenuItemSelected={jobMenuSelectedFromHelperMenu}
                  subMenuStyle={{
                    minWidth: 210
                  }}
                  menuStyle={(i: number) => ({
                    maxHeight: 500,
                    zIndex: 214748364,
                    padding: 0,
                    overflowY: 'auto',
                    // border:'1px solid #595959',
                    border: useDarkMode ? '3px solid #6C747E' : '3px solid #7DBBFE',
                    borderRadius: '5px',
                    backgroundColor: useDarkMode ? '#141414' : '#E0FFFF',
                  })}
                />
                <div ref={setArrowElement} style={styles.arrow} />
              </div>
            </div>
          }
        </div>
        {/* } */}

        <div className="clearfix" />
      </div>
    </div>
  );
};

JobSwitchingMenu.defaultProps = {
  testMode: false,
};

JobSwitchingMenu.propTypes = {
  testMode: PropTypes.bool.isRequired,
  resetJobMenuContextState: PropTypes.func.isRequired,
};

export default React.memo(JobSwitchingMenu);
